// import React, { useState, useEffect } from 'react';
// import {
//   Table,
//   Button,
//   Modal,
//   Form,
//   Input,
//   Switch,
//   Select,
//   Tag,
//   Space,
//   message,
//   Popconfirm,
//   Card,
//   Row,
//   Col,
//   Typography,
//   Upload,
//   Image,
//   Tooltip,
//   InputNumber,
//   Alert,
//   Badge
// } from 'antd';
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   InboxOutlined,
//   LinkOutlined,
//   FileImageOutlined,
//   ClockCircleOutlined,
//   UserOutlined,
//   TagOutlined,
//   CalendarOutlined
// } from '@ant-design/icons';
// import courseService from '../../services/course.service';

// const { Title, Text, Paragraph } = Typography;
// const { TextArea } = Input;
// const { Option } = Select;
// const { Dragger } = Upload;

// const NewsManager = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [previewVisible, setPreviewVisible] = useState(false);
//   const [editingNews, setEditingNews] = useState(null);
//   const [previewNews, setPreviewNews] = useState(null);
//   const [form] = Form.useForm();
//   const [submitting, setSubmitting] = useState(false);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [imageType, setImageType] = useState('url'); // 'url' ou 'upload'

//   // Catégories d'actualités
//   const categoryOptions = [
//     { value: 'elearning', label: 'E-Learning', color: '#1890ff' },
//     { value: 'technology', label: 'Technologie', color: '#722ed1' },
//     { value: 'education', label: 'Éducation', color: '#52c41a' },
//     { value: 'innovation', label: 'Innovation', color: '#faad14' },
//     { value: 'updates', label: 'Mises à jour', color: '#f5222d' },
//     { value: 'events', label: 'Événements', color: '#13c2c2' }
//   ];

//   useEffect(() => {
//     fetchNews();
//   }, []);

//   const fetchNews = async () => {
//     setLoading(true);
//     try {
//       const response = await courseService.getAllNews();
//       setNews(response);
//     } catch (error) {
//       message.error('Erreur lors du chargement des actualités');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCreate = () => {
//     setEditingNews(null);
//     form.resetFields();
//     setImagePreview(null);
//     setImageType('url');
//     setSubmitting(false);
//     setModalVisible(true);
//   };

//   const handleEdit = (newsItem) => {
//     setEditingNews(newsItem);
//     setSubmitting(false);
    
//     form.setFieldsValue({
//       title: newsItem.title,
//       content: newsItem.content,
//       summary: newsItem.summary,
//       category: newsItem.category,
//       author: newsItem.author,
//       readingTime: newsItem.readingTime,
//       published: newsItem.published,
//       imageData: newsItem.imageData
//     });

//     if (newsItem.imageData) {
//       setImagePreview(newsItem.imageType === 'base64' 
//         ? `data:image/jpeg;base64,${newsItem.imageData}` 
//         : newsItem.imageData
//       );
//       setImageType(newsItem.imageType || 'url');
//     } else {
//       setImagePreview(null);
//     }

//     setModalVisible(true);
//   };

//   const handlePreview = (newsItem) => {
//     setPreviewNews(newsItem);
//     setPreviewVisible(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await courseService.deleteNews(id);
//       message.success('Actualité supprimée avec succès');
//       fetchNews();
//     } catch (error) {
//       message.error('Erreur lors de la suppression');
//       console.error(error);
//     }
//   };

//   const handleSubmit = async (values) => {
//     setSubmitting(true);
//     try {
//       const newsData = {
//         ...values,
//         imageType: imageType,
//         imageData: imagePreview ? form.getFieldValue('imageData') : null
//       };

//       const apiCall = editingNews 
//         ? courseService.updateNews(editingNews.id, newsData)
//         : courseService.createNews(newsData);
      
//       const minDelay = new Promise(resolve => setTimeout(resolve, 800));
      
//       await Promise.all([apiCall, minDelay]);

//       message.success(editingNews ? 'Actualité modifiée avec succès' : 'Actualité créée avec succès');
//       setModalVisible(false);
//       fetchNews();
//     } catch (error) {
//       message.error('Erreur lors de la sauvegarde');
//       console.error(error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleImageTypeChange = (type) => {
//     setImageType(type);
//     setImagePreview(null);
//     form.setFieldsValue({ imageData: '' });
//   };

//   const handleUrlImageChange = (e) => {
//     const url = e.target.value;
//     form.setFieldsValue({ imageData: url });
//     if (url) {
//       setImagePreview(url);
//     } else {
//       setImagePreview(null);
//     }
//   };

//   const handleFileUpload = (info) => {
//     const { status } = info.file;
//     if (status === 'done') {
//       // Simuler l'upload en base64 pour la démo
//       const reader = new FileReader();
//       reader.onload = () => {
//         const base64 = reader.result.split(',')[1]; // Enlever le préfixe data:image/...;base64,
//         form.setFieldsValue({ imageData: base64 });
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(info.file.originFileObj);
//       message.success(`${info.file.name} uploadé avec succès`);
//     } else if (status === 'error') {
//       message.error(`${info.file.name} erreur d'upload`);
//     }
//   };

//   const getCategoryInfo = (categoryValue) => {
//     return categoryOptions.find(cat => cat.value === categoryValue) || 
//            { label: categoryValue, color: '#666' };
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     return new Date(dateString).toLocaleDateString('fr-FR', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const columns = [
//     {
//       title: 'Titre',
//       dataIndex: 'title',
//       key: 'title',
//       ellipsis: true,
//       width: 250,
//       render: (text, record) => (
//         <div>
//           <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
//             {text}
//           </div>
//           {record.summary && (
//             <Text type="secondary" style={{ fontSize: '12px' }}>
//               {record.summary.substring(0, 80)}...
//             </Text>
//           )}
//         </div>
//       )
//     },
//     {
//       title: 'Catégorie',
//       dataIndex: 'category',
//       key: 'category',
//       width: 120,
//       render: (category) => {
//         const categoryInfo = getCategoryInfo(category);
//         return category ? (
//           <Tag color={categoryInfo.color}>
//             {categoryInfo.label}
//           </Tag>
//         ) : '-';
//       }
//     },
//     {
//       title: 'Auteur',
//       dataIndex: 'author',
//       key: 'author',
//       width: 120,
//       render: (author) => (
//         <Space>
//           <UserOutlined style={{ color: '#666' }} />
//           <span>{author || 'Anonyme'}</span>
//         </Space>
//       )
//     },
//     {
//       title: 'Lecture',
//       dataIndex: 'readingTime',
//       key: 'readingTime',
//       width: 80,
//       render: (time) => time ? (
//         <Space>
//           <ClockCircleOutlined style={{ color: '#666' }} />
//           <span>{time}min</span>
//         </Space>
//       ) : '-'
//     },
//     {
//       title: 'Date',
//       dataIndex: 'createdDate',
//       key: 'createdDate',
//       width: 140,
//       render: (date) => (
//         <div>
//           <CalendarOutlined style={{ marginRight: 4, color: '#666' }} />
//           {formatDate(date)}
//         </div>
//       )
//     },
//     {
//       title: 'Statut',
//       dataIndex: 'published',
//       key: 'published',
//       width: 80,
//       render: (published) => (
//         <Badge 
//           status={published ? 'success' : 'default'} 
//           text={published ? 'Publié' : 'Brouillon'} 
//         />
//       )
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       width: 150,
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="Prévisualiser">
//             <Button
//               type="default"
//               size="small"
//               icon={<EyeOutlined />}
//               onClick={() => handlePreview(record)}
//             />
//           </Tooltip>
//           <Tooltip title="Modifier">
//             <Button
//               type="primary"
//               size="small"
//               icon={<EditOutlined />}
//               onClick={() => handleEdit(record)}
//             />
//           </Tooltip>
//           <Popconfirm
//             title="Supprimer cette actualité ?"
//             description="Cette action est irréversible."
//             onConfirm={() => handleDelete(record.id)}
//             okText="Oui"
//             cancelText="Non"
//             okType="danger"
//           >
//             <Tooltip title="Supprimer">
//               <Button
//                 danger
//                 size="small"
//                 icon={<DeleteOutlined />}
//               />
//             </Tooltip>
//           </Popconfirm>
//         </Space>
//       )
//     }
//   ];

//   return (
//     <div style={{ padding: '20px' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
//         <Title level={3}>Gestion des Actualités</Title>
//         <Button
//           type="primary"
//           icon={<PlusOutlined />}
//           onClick={handleCreate}
//           size="large"
//         >
//           Nouvelle Actualité
//         </Button>
//       </div>

//       <Table
//         columns={columns}
//         dataSource={news}
//         rowKey="id"
//         loading={loading}
//         pagination={{ 
//           pageSize: 10,
//           showSizeChanger: true,
//           showQuickJumper: true,
//           showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} actualités`
//         }}
//         scroll={{ x: 1200 }}
//       />

//       {/* Modal Création/Édition */}
//       <Modal
//         title={
//           <Space>
//             <FileImageOutlined />
//             {editingNews ? 'Modifier l\'Actualité' : 'Nouvelle Actualité'}
//           </Space>
//         }
//         open={modalVisible}
//         onCancel={() => {
//           setModalVisible(false);
//           setSubmitting(false);
//         }}
//         footer={null}
//         width={900}
//         maskClosable={!submitting}
//         closable={!submitting}
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//         >
//           <Row gutter={16}>
//             <Col span={16}>
//               <Form.Item
//                 name="title"
//                 label="Titre"
//                 rules={[{ required: true, message: 'Le titre est obligatoire' }]}
//               >
//                 <Input 
//                   placeholder="Titre accrocheur de l'actualité"
//                   showCount
//                   maxLength={150}
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="category"
//                 label="Catégorie"
//                 rules={[{ required: true, message: 'La catégorie est obligatoire' }]}
//               >
//                 <Select placeholder="Sélectionner une catégorie">
//                   {categoryOptions.map(category => (
//                     <Option key={category.value} value={category.value}>
//                       <Tag color={category.color} style={{ margin: 0 }}>
//                         {category.label}
//                       </Tag>
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           <Form.Item
//             name="summary"
//             label="Résumé"
//             rules={[{ required: true, message: 'Le résumé est obligatoire' }]}
//           >
//             <TextArea 
//               placeholder="Résumé court qui apparaîtra sur les cartes"
//               showCount
//               maxLength={200}
//               rows={3}
//             />
//           </Form.Item>

//           <Form.Item
//             name="content"
//             label="Contenu"
//             rules={[{ required: true, message: 'Le contenu est obligatoire' }]}
//           >
//             <TextArea 
//               placeholder="Contenu détaillé de l'actualité"
//               showCount
//               maxLength={5000}
//               rows={6}
//             />
//           </Form.Item>

//           {/* Section Image */}
//           <Card size="small" title="Image de l'actualité" style={{ marginBottom: 16 }}>
//             <div style={{ marginBottom: 16 }}>
//               <Space>
//                 <Button 
//                   type={imageType === 'url' ? 'primary' : 'default'}
//                   icon={<LinkOutlined />}
//                   onClick={() => handleImageTypeChange('url')}
//                 >
//                   URL
//                 </Button>
//                 <Button 
//                   type={imageType === 'upload' ? 'primary' : 'default'}
//                   icon={<InboxOutlined />}
//                   onClick={() => handleImageTypeChange('upload')}
//                 >
//                   Upload
//                 </Button>
//               </Space>
//             </div>

//             {imageType === 'url' ? (
//               <Form.Item
//                 name="imageData"
//                 label="URL de l'image"
//               >
//                 <Input 
//                   placeholder="https://exemple.com/image.jpg"
//                   onChange={handleUrlImageChange}
//                 />
//               </Form.Item>
//             ) : (
//               <Form.Item
//                 name="imageData"
//                 label="Upload de l'image"
//               >
//                 <Dragger
//                   accept="image/*"
//                   showUploadList={false}
//                   customRequest={({ file, onSuccess }) => {
//                     setTimeout(() => onSuccess("ok"), 0);
//                   }}
//                   onChange={handleFileUpload}
//                 >
//                   <p className="ant-upload-drag-icon">
//                     <InboxOutlined />
//                   </p>
//                   <p className="ant-upload-text">Cliquez ou glissez une image ici</p>
//                   <p className="ant-upload-hint">
//                     Formats supportés: JPG, PNG, GIF (max 5MB)
//                   </p>
//                 </Dragger>
//               </Form.Item>
//             )}

//             {imagePreview && (
//               <div style={{ marginTop: 16, textAlign: 'center' }}>
//                 <Image
//                   width={200}
//                   height={120}
//                   src={imagePreview}
//                   style={{ objectFit: 'cover', borderRadius: 8 }}
//                   placeholder={<div>Chargement...</div>}
//                 />
//               </div>
//             )}
//           </Card>

//           <Row gutter={16}>
//             <Col span={8}>
//               <Form.Item
//                 name="author"
//                 label="Auteur"
//               >
//                 <Input 
//                   placeholder="Nom de l'auteur"
//                   prefix={<UserOutlined />}
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="readingTime"
//                 label="Temps de lecture (minutes)"
//               >
//                 <InputNumber
//                   style={{ width: '100%' }}
//                   min={1}
//                   max={60}
//                   placeholder="5"
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="published"
//                 label="Publier immédiatement"
//                 valuePropName="checked"
//               >
//                 <Switch />
//               </Form.Item>
//             </Col>
//           </Row>

//           <div style={{ textAlign: 'right', marginTop: '24px' }}>
//             <Space>
//               <Button 
//                 onClick={() => setModalVisible(false)}
//                 disabled={submitting}
//               >
//                 Annuler
//               </Button>
//               <Button 
//                 type="primary" 
//                 htmlType="submit"
//                 loading={submitting}
//                 disabled={submitting}
//               >
//                 {editingNews ? 'Modifier' : 'Créer'}
//               </Button>
//             </Space>
//           </div>
//         </Form>
//       </Modal>

//       {/* Modal Prévisualisation */}
//       <Modal
//         title={
//           <Space>
//             <EyeOutlined />
//             Prévisualisation
//           </Space>
//         }
//         open={previewVisible}
//         onCancel={() => setPreviewVisible(false)}
//         footer={[
//           <Button key="close" onClick={() => setPreviewVisible(false)}>
//             Fermer
//           </Button>
//         ]}
//         width={700}
//       >
//         {previewNews && (
//           <div>
//             {/* Image */}
//             {previewNews.imageData && (
//               <div style={{ marginBottom: 16, textAlign: 'center' }}>
//                 <Image
//                   width="100%"
//                   height={250}
//                   src={previewNews.imageType === 'base64' 
//                     ? `data:image/jpeg;base64,${previewNews.imageData}` 
//                     : previewNews.imageData
//                   }
//                   style={{ objectFit: 'cover', borderRadius: 8 }}
//                 />
//               </div>
//             )}

//             {/* Métadonnées */}
//             <div style={{ marginBottom: 16 }}>
//               <Space wrap>
//                 {previewNews.category && (
//                   <Tag color={getCategoryInfo(previewNews.category).color}>
//                     {getCategoryInfo(previewNews.category).label}
//                   </Tag>
//                 )}
//                 <Text type="secondary">
//                   <CalendarOutlined /> {formatDate(previewNews.createdDate)}
//                 </Text>
//                 {previewNews.readingTime && (
//                   <Text type="secondary">
//                     <ClockCircleOutlined /> {previewNews.readingTime} min
//                   </Text>
//                 )}
//                 {previewNews.author && (
//                   <Text type="secondary">
//                     <UserOutlined /> {previewNews.author}
//                   </Text>
//                 )}
//               </Space>
//             </div>

//             {/* Titre */}
//             <Title level={3} style={{ marginBottom: 12 }}>
//               {previewNews.title}
//             </Title>

//             {/* Résumé */}
//             {previewNews.summary && (
//               <Alert
//                 message="Résumé"
//                 description={previewNews.summary}
//                 type="info"
//                 style={{ marginBottom: 16 }}
//               />
//             )}

//             {/* Contenu */}
//             <Paragraph style={{ fontSize: 16, lineHeight: 1.6 }}>
//               {previewNews.content}
//             </Paragraph>
//           </div>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default NewsManager;


import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Select,
  Tag,
  Space,
  message,
  Popconfirm,
  Card,
  Row,
  Col,
  Typography,
  Upload,
  Image,
  Tooltip,
  InputNumber,
  Alert,
  Badge
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  InboxOutlined,
  LinkOutlined,
  FileImageOutlined,
  ClockCircleOutlined,
  UserOutlined,
  TagOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import courseService from '../../services/course.service';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const { Dragger } = Upload;

const NewsManager = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [previewNews, setPreviewNews] = useState(null);
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageType, setImageType] = useState('url'); // 'url' ou 'upload'

  // Catégories d'actualités
  const categoryOptions = [
    { value: 'elearning', label: 'E-Learning', color: '#1890ff' },
    { value: 'technology', label: 'Technologie', color: '#722ed1' },
    { value: 'education', label: 'Éducation', color: '#52c41a' },
    { value: 'innovation', label: 'Innovation', color: '#faad14' },
    { value: 'updates', label: 'Mises à jour', color: '#f5222d' },
    { value: 'events', label: 'Événements', color: '#13c2c2' }
  ];

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await courseService.getAllNews();
      setNews(response);
    } catch (error) {
      message.error('Erreur lors du chargement des actualités');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingNews(null);
    form.resetFields();
    setImagePreview(null);
    setImageType('url');
    setSubmitting(false);
    setModalVisible(true);
  };

  const handleEdit = (newsItem) => {
    setEditingNews(newsItem);
    setSubmitting(false);
    
    form.setFieldsValue({
      title: newsItem.title,
      content: newsItem.content,
      summary: newsItem.summary,
      category: newsItem.category,
      author: newsItem.author,
      readingTime: newsItem.readingTime,
      published: newsItem.published,
      imageData: newsItem.imageData
    });

    if (newsItem.imageData) {
      setImagePreview(newsItem.imageType === 'base64' 
        ? `data:image/jpeg;base64,${newsItem.imageData}` 
        : newsItem.imageData
      );
      setImageType(newsItem.imageType || 'url');
    } else {
      setImagePreview(null);
    }

    setModalVisible(true);
  };

  const handlePreview = (newsItem) => {
    setPreviewNews(newsItem);
    setPreviewVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await courseService.deleteNews(id);
      message.success('Actualité supprimée avec succès');
      fetchNews();
    } catch (error) {
      message.error('Erreur lors de la suppression');
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      const imageData = form.getFieldValue('imageData');
      const newsData = {
        ...values,
        imageType: imageType,
        imageData: imageData || null
      };
      
      console.log('Données envoyées:', { imageType, imageData: imageData ? 'Image présente' : 'Pas d\'image' });

      const apiCall = editingNews 
        ? courseService.updateNews(editingNews.id, newsData)
        : courseService.createNews(newsData);
      
      const minDelay = new Promise(resolve => setTimeout(resolve, 800));
      
      await Promise.all([apiCall, minDelay]);

      message.success(editingNews ? 'Actualité modifiée avec succès' : 'Actualité créée avec succès');
      setModalVisible(false);
      fetchNews();
    } catch (error) {
      message.error('Erreur lors de la sauvegarde');
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleImageTypeChange = (type) => {
    setImageType(type);
    setImagePreview(null);
    form.setFieldsValue({ imageData: '' });
  };

  const handleUrlImageChange = (e) => {
    const url = e.target.value;
    form.setFieldsValue({ imageData: url });
    if (url) {
      setImagePreview(url);
    } else {
      setImagePreview(null);
    }
  };

  const handleFileUpload = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      const file = info.file.originFileObj;
      
      // Vérifier la taille du fichier (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        message.error('L\'image ne doit pas dépasser 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        
        // Vérifier la taille en base64 (approximativement 1.37x la taille originale)
        if (base64.length > 3 * 1024 * 1024) { // ~3MB en base64
          message.error('L\'image est trop volumineuse après conversion. Veuillez choisir une image plus petite.');
          return;
        }
        
        form.setFieldsValue({ imageData: base64 });
        setImagePreview(reader.result);
        message.success(`${info.file.name} uploadé avec succès`);
      };
      reader.readAsDataURL(file);
    } else if (status === 'error') {
      message.error(`${info.file.name} erreur d'upload`);
    }
  };

  const getCategoryInfo = (categoryValue) => {
    return categoryOptions.find(cat => cat.value === categoryValue) || 
           { label: categoryValue, color: '#666' };
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const columns = [
    {
      title: 'Titre',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      width: 250,
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
            {text}
          </div>
          {record.summary && (
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {record.summary.substring(0, 80)}...
            </Text>
          )}
        </div>
      )
    },
    {
      title: 'Catégorie',
      dataIndex: 'category',
      key: 'category',
      width: 120,
      render: (category) => {
        const categoryInfo = getCategoryInfo(category);
        return category ? (
          <Tag color={categoryInfo.color}>
            {categoryInfo.label}
          </Tag>
        ) : '-';
      }
    },
    {
      title: 'Auteur',
      dataIndex: 'author',
      key: 'author',
      width: 120,
      render: (author) => (
        <Space>
          <UserOutlined style={{ color: '#666' }} />
          <span>{author || 'Anonyme'}</span>
        </Space>
      )
    },
    {
      title: 'Lecture',
      dataIndex: 'readingTime',
      key: 'readingTime',
      width: 80,
      render: (time) => time ? (
        <Space>
          <ClockCircleOutlined style={{ color: '#666' }} />
          <span>{time}min</span>
        </Space>
      ) : '-'
    },
    {
      title: 'Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 140,
      render: (date) => (
        <div>
          <CalendarOutlined style={{ marginRight: 4, color: '#666' }} />
          {formatDate(date)}
        </div>
      )
    },
    {
      title: 'Statut',
      dataIndex: 'published',
      key: 'published',
      width: 80,
      render: (published) => (
        <Badge 
          status={published ? 'success' : 'default'} 
          text={published ? 'Publié' : 'Brouillon'} 
        />
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 150,
      render: (_, record) => (
        <Space>
          <Tooltip title="Prévisualiser">
            <Button
              type="default"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => handlePreview(record)}
            />
          </Tooltip>
          <Tooltip title="Modifier">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Supprimer cette actualité ?"
            description="Cette action est irréversible."
            onConfirm={() => handleDelete(record.id)}
            okText="Oui"
            cancelText="Non"
            okType="danger"
          >
            <Tooltip title="Supprimer">
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Title level={3}>Gestion des Actualités</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreate}
          size="large"
        >
          Nouvelle Actualité
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={news}
        rowKey="id"
        loading={loading}
        pagination={{ 
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} actualités`
        }}
        scroll={{ x: 1200 }}
      />

      {/* Modal Création/Édition */}
      <Modal
        title={
          <Space>
            <FileImageOutlined />
            {editingNews ? 'Modifier l\'Actualité' : 'Nouvelle Actualité'}
          </Space>
        }
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setSubmitting(false);
        }}
        footer={null}
        width={900}
        maskClosable={!submitting}
        closable={!submitting}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="title"
                label="Titre"
                rules={[{ required: true, message: 'Le titre est obligatoire' }]}
              >
                <Input 
                  placeholder="Titre accrocheur de l'actualité"
                  showCount
                  maxLength={150}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="category"
                label="Catégorie"
                rules={[{ required: true, message: 'La catégorie est obligatoire' }]}
              >
                <Select placeholder="Sélectionner une catégorie">
                  {categoryOptions.map(category => (
                    <Option key={category.value} value={category.value}>
                      <Tag color={category.color} style={{ margin: 0 }}>
                        {category.label}
                      </Tag>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="summary"
            label="Résumé"
            rules={[{ required: true, message: 'Le résumé est obligatoire' }]}
          >
            <TextArea 
              placeholder="Résumé court qui apparaîtra sur les cartes"
              showCount
              maxLength={200}
              rows={3}
            />
          </Form.Item>

          <Form.Item
            name="content"
            label="Contenu"
            rules={[{ required: true, message: 'Le contenu est obligatoire' }]}
          >
            <TextArea 
              placeholder="Contenu détaillé de l'actualité"
              showCount
              maxLength={5000}
              rows={6}
            />
          </Form.Item>

          {/* Section Image */}
          <Card size="small" title="Image de l'actualité" style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 16 }}>
              <Space>
                <Button 
                  type={imageType === 'url' ? 'primary' : 'default'}
                  icon={<LinkOutlined />}
                  onClick={() => handleImageTypeChange('url')}
                >
                  URL
                </Button>
                <Button 
                  type={imageType === 'upload' ? 'primary' : 'default'}
                  icon={<InboxOutlined />}
                  onClick={() => handleImageTypeChange('upload')}
                >
                  Upload
                </Button>
              </Space>
            </div>

            {imageType === 'url' ? (
              <Form.Item
                name="imageData"
                label="URL de l'image"
              >
                <Input 
                  placeholder="https://exemple.com/image.jpg"
                  onChange={handleUrlImageChange}
                />
              </Form.Item>
            ) : (
              <Form.Item
                name="imageData"
                label="Upload de l'image"
              >
                <Dragger
                  accept="image/*"
                  showUploadList={false}
                  beforeUpload={(file) => {
                    // Vérification de la taille avant upload
                    if (file.size > 5 * 1024 * 1024) {
                      message.error('L\'image ne doit pas dépasser 5MB');
                      return false;
                    }
                    return true;
                  }}
                  customRequest={({ file, onSuccess }) => {
                    setTimeout(() => onSuccess("ok"), 0);
                  }}
                  onChange={handleFileUpload}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Cliquez ou glissez une image ici</p>
                  <p className="ant-upload-hint">
                    Formats supportés: JPG, PNG, GIF (max 5MB)
                  </p>
                </Dragger>
              </Form.Item>
            )}

            {imagePreview && (
              <div style={{ marginTop: 16, textAlign: 'center' }}>
                <Image
                  width={200}
                  height={120}
                  src={imagePreview}
                  style={{ objectFit: 'cover', borderRadius: 8 }}
                  placeholder={<div>Chargement...</div>}
                />
              </div>
            )}
          </Card>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="author"
                label="Auteur"
              >
                <Input 
                  placeholder="Nom de l'auteur"
                  prefix={<UserOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="readingTime"
                label="Temps de lecture (minutes)"
              >
                <InputNumber
                  style={{ width: '100%' }}
                  min={1}
                  max={60}
                  placeholder="5"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="published"
                label="Publier immédiatement"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ textAlign: 'right', marginTop: '24px' }}>
            <Space>
              <Button 
                onClick={() => setModalVisible(false)}
                disabled={submitting}
              >
                Annuler
              </Button>
              <Button 
                type="primary" 
                htmlType="submit"
                loading={submitting}
                disabled={submitting}
              >
                {editingNews ? 'Modifier' : 'Créer'}
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>

      {/* Modal Prévisualisation */}
      <Modal
        title={
          <Space>
            <EyeOutlined />
            Prévisualisation
          </Space>
        }
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        footer={[
          <Button key="close" onClick={() => setPreviewVisible(false)}>
            Fermer
          </Button>
        ]}
        width={700}
      >
        {previewNews && (
          <div>
            {/* Image */}
            {previewNews.imageData && (
              <div style={{ marginBottom: 16, textAlign: 'center' }}>
                <Image
                  width="100%"
                  height={250}
                  src={previewNews.imageType === 'base64' 
                    ? `data:image/jpeg;base64,${previewNews.imageData}` 
                    : previewNews.imageData
                  }
                  style={{ objectFit: 'cover', borderRadius: 8 }}
                />
              </div>
            )}

            {/* Métadonnées */}
            <div style={{ marginBottom: 16 }}>
              <Space wrap>
                {previewNews.category && (
                  <Tag color={getCategoryInfo(previewNews.category).color}>
                    {getCategoryInfo(previewNews.category).label}
                  </Tag>
                )}
                <Text type="secondary">
                  <CalendarOutlined /> {formatDate(previewNews.createdDate)}
                </Text>
                {previewNews.readingTime && (
                  <Text type="secondary">
                    <ClockCircleOutlined /> {previewNews.readingTime} min
                  </Text>
                )}
                {previewNews.author && (
                  <Text type="secondary">
                    <UserOutlined /> {previewNews.author}
                  </Text>
                )}
              </Space>
            </div>

            {/* Titre */}
            <Title level={3} style={{ marginBottom: 12 }}>
              {previewNews.title}
            </Title>

            {/* Résumé */}
            {previewNews.summary && (
              <Alert
                message="Résumé"
                description={previewNews.summary}
                type="info"
                style={{ marginBottom: 16 }}
              />
            )}

            {/* Contenu */}
            <Paragraph style={{ fontSize: 16, lineHeight: 1.6 }}>
              {previewNews.content}
            </Paragraph>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default NewsManager;